import { Box, SelectBox } from "arkh";
import { FormattedMessage } from "react-intl";

export function OrgAdminTopicsPrivateToggle(props: {
  isPrivate: boolean;
  onChange: (isPrivate: boolean) => void;
}) {
  return (
    <Box style={{ flexDirection: "row", maxWidth: 400 }}>
      <SelectBox
        isSelected={!props.isPrivate}
        icon="users"
        onPress={() => {
          props.onChange(false);
        }}
      >
        <FormattedMessage
          defaultMessage="Default"
          description="OrgAdminTopicsPrivateToggle Public"
        />
      </SelectBox>
      <SelectBox
        isSelected={props.isPrivate}
        icon="locked"
        onPress={() => {
          props.onChange(true);
        }}
      >
        <FormattedMessage
          defaultMessage="Locked Topic"
          description="OrgAdminTopicsPrivateToggle Private"
        />
      </SelectBox>
    </Box>
  );
}
